let equation = "x^{hello}"



// I think for styles, you store it as properties.
// And only when you actually display it, you compute ranges based on all those properties.
// That's pretty easy.


const styleRangeMap = {
  "color.green":[[1,4],[7,11]],
  "textDecoration.italic":[[3,8]],
}

let flattened = Object.values(styleRangeMap).flat().flat()
console.log({flattened});
let maxIndex = Math.max(...flattened) + 1

let arr = Array(maxIndex).fill(null).map(() => ({ s:[], e:[] }));

Object.entries(styleRangeMap).forEach(([key,ranges]) => {

  ranges.forEach(range => {
    let [ s, e ] = range;
    arr[s].s.push(key)
    arr[e].e.push(key);
  })

})

console.log(arr);




let curItem = { s:0,e:0, styles:[] }
let stylesAndRanges = [curItem];

arr.forEach((char,ii) => {


  let newStyles = curItem.styles.slice();
  let startingSomething = char.s.length > 0;
  let endingSomething = char.e.length > 0;
  if( startingSomething ){
    curItem.e = ii;
    newStyles.push(...char.s);
  }

  if( endingSomething ){
    curItem.e = ii;
    newStyles = newStyles.filter(x => !char.e.includes(x));
  }

  if( startingSomething || endingSomething ){

    curItem = {
      s:ii,
      e:ii,
      styles:newStyles
    }
    stylesAndRanges.push(curItem)
  }else{
    curItem.e = ii;
  }

})


console.log(stylesAndRanges);






//from here, you just compute where the stops and starts are...
//and then you just use that to compute the styles for each "block"


function parseLatex(string){

  let state = "baseline";
  
  let currentPart = { tag:"span", content:"" }
  let parts = [currentPart];

  for(let ii = 0; ii < string.length; ii++){

    let char = string[ii];

    if( char === "^" ){

      currentPart = {tag:"sup", content:"" }
      parts.push(currentPart)

    }else if( char === "_" ){

      currentPart = {tag:"sub", content:"" }
      parts.push(currentPart)
      
    }else if( char === "{" ){

      state = "in-bracket";

    }else if( char === "}" ){

      state = "baseline";
      currentPart = {tag:"span", content:"" }
      parts.push(currentPart)

    }else{
      currentPart.content += char;
    }

  }

  return parts.filter(x => x.content.length > 0);


}


//console.log(parseLatex(equation));

//export default function AdvancedEquation(){ }
